import {Badge} from "@mantine/core";
import {I18n} from "@aws-amplify/core";

// Theme colour names, not hex, so light and dark both work (§2). The one status badge
// for the module: the table column and the detail card both render it.
const colors: { [key: string]: string } = {
    'Active': 'blue',
    'Deprecated': 'gray',
    'Draft': 'yellow',
};

export const StatusBadge = ({status}: { status?: string }) => (
    <Badge color={status ? colors[status] ?? 'gray' : 'gray'} variant='light'>
        {status ? I18n.get(status) : '—'}
    </Badge>
);
